import dynamic from "next/dynamic";
import { SHARE_HOLDING_GRAPH_COLORS } from "./StockShareHoldingContants";
import { IPieChart } from "../../interfaces/StockShareholding.interface";
import BFLLazyLoad from "@repo/shared-ui/BFLLazyLoad";
import useMediaQuery from "@repo/shared-ui/useMediaQuery";
import BFLSkeleton from "@repo/shared-ui/BFLSkeleton";

const LoadingSkeleton = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  return <BFLSkeleton count={1} height={isMobile ? 120 : 205} />;
};


const ShareholdingSummaryChart: any = dynamic(
  () => import("./ShareholdingSummaryChart.tsx") as any,
  { ssr: false,
    loading: () => <LoadingSkeleton />,
   },
);

const ShareholdingSummaryTab = ({
  data,
  graphLabel,
}: {
  data: IPieChart | { [key: string]: number | undefined };
  graphLabel: string[];
}) => {
  const series = [
    data?.others,
    data?.promHolding,
    data?.fii,
    data?.dii,
    data?.promShares,
  ].filter((value): value is number => value !== undefined && value !== null);
  const SHARE_HOLDING_GRAPH_LABEL = graphLabel;
  const isMobile = useMediaQuery("(max-width: 996px)");

  return (
    <div className="md:bg-lgray-100 flex h-[152px] items-center gap-9 rounded-[8px] pb-4 pt-2 md:h-auto md:flex-col md:gap-4 md:px-6">
      <div
        className={`flex w-[${isMobile ? "120px" : "300px"}] items-center justify-center`}
      >
        <BFLLazyLoad className="min-w-[120px] md:min-w-[300px] min-h-[120px] md:min-h-[205px]" threshold={0.3}>
          <ShareholdingSummaryChart
            series={series}
            SHARE_HOLDING_GRAPH_LABEL={SHARE_HOLDING_GRAPH_LABEL}
          />
        </BFLLazyLoad>
      </div>
      <div className="flex w-full max-w-xs flex-col items-start gap-2 overflow-y-auto md:gap-4">
        {SHARE_HOLDING_GRAPH_LABEL?.map((label, idx) => (
          <div
            key={idx}
            className="flex w-full items-center justify-between text-lg text-gray-900"
          >
            <div className="my-0 flex items-center gap-[12px]">
              <span
                className="h-[10px] w-[10px]"
                style={{ backgroundColor: SHARE_HOLDING_GRAPH_COLORS[idx] }}
              ></span>
              <span className="text-xs leading-[18.95px] text-gray-600 md:text-base">
                {label}
              </span>
            </div>
            <span className="mx-[10px] my-0 text-xs text-gray-700 md:text-base">
              {series[idx]+"%"}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
export default ShareholdingSummaryTab;
